import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Check } from "lucide-react";

export function CollaboratorSelect({ valueId, onSelect }) {
  const [colabs, setColabs] = useState([]);
  const [q, setQ] = useState("");
  const [openList, setOpenList] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { api.get("/collaborators", { params: { active: true } }).then((r) => setColabs(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const sel = colabs.find((c) => c.id === valueId);
    if (sel) setQ(sel.nome);
  }, [valueId, colabs]);
  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpenList(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const term = q.trim().toLowerCase();
  const filtered = term ? colabs.filter((c) => c.nome.toLowerCase().includes(term) || (c.funcao || "").toLowerCase().includes(term) || (c.setor || "").toLowerCase().includes(term)) : colabs;

  return (
    <div className="relative" ref={boxRef}>
      <Input
        data-testid="input-retirado-por"
        value={q}
        onChange={(e) => { setQ(e.target.value); onSelect(null, ""); setOpenList(true); }}
        onFocus={() => setOpenList(true)}
        placeholder="Buscar colaborador ativo..."
        className="mt-1 bg-slate-950 border-slate-700 h-12"
      />
      {openList && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-slate-700 bg-slate-900 shadow-xl">
          {filtered.length === 0 ? (
            <div className="px-3 py-3 text-sm text-slate-500">Nenhum colaborador ativo encontrado.</div>
          ) : filtered.map((c) => (
            <button
              key={c.id}
              type="button"
              data-testid={`retirado-por-option-${c.id}`}
              onClick={() => { onSelect(c.id, c.nome); setQ(c.nome); setOpenList(false); }}
              className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm text-slate-200 hover:bg-slate-800"
            >
              <span><span className="font-medium">{c.nome}</span>{(c.funcao || c.setor) && <span className="text-xs text-slate-500"> · {[c.funcao, c.setor].filter(Boolean).join(" / ")}</span>}</span>
              {valueId === c.id && <Check className="h-4 w-4 text-sky-400" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
